<div class="container">
  <fc-dashboard-banner
    [showTotals]="currentUser?.isVerified"
    [totalSitesAcres]="totalSitesAcres"
    [totalSitesValue]="totalSitesValue"></fc-dashboard-banner>

  <ng-container *ngIf="currentUser?.isVerified; else notVerified">
    <div class="main-container">
      <div class="main">
        <ng-container *ngIf="this.landowners.length > 0 && landownerSelectionForm">
          <form [formGroup]="landownerSelectionForm" class="landowner-selection">
            <div class="landowner-dropdown">
              <mat-form-field class="landowner-select">
                <mat-label>Select a Landowner</mat-label>
                <mat-select
                  (selectionChange)="changeLandowner($event)"
                  [value]="getActAsUserSubject()"
                  formControlName="landowner"
                  placeholder="Yourself">
                  <mat-option>Yourself</mat-option>
                  <mat-option *ngFor="let landowner of landowners" [value]="landowner.cognitoSubject">
                    {{
                      landowner.getDisplayName({
                        reverse: true,
                        includeEmail: true
                      })
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </form>
        </ng-container>
        <div class="header-div">
          <div class="site-list-heading">
            Your
            {{ actAsUser && actAsUser.id !== currentUser.id ? 'Managed ' : ' ' }}Carbon Offset Sites
          </div>
          <div class="button-div">
            <button
              (click)="doGoToNewSite()"
              color="primary"
              mat-stroked-button
              type="button"
              class="add-site-button">
              <fa-icon [icon]="['fas', 'plus']"></fa-icon>
              Add New Site
            </button>
          </div>
        </div>
        <div *ngIf="availableSites">
          <div *ngIf="availableSites.length > 0; else noSites" class="sites-container">
            <div *ngFor="let site of availableSites" class="site-card-item">
              <fc-site-card (deleteSite)="doDeleteSite($event)" [site]="site"></fc-site-card>
            </div>
          </div>

          <ng-template #noSites>
            <div class="sites-container centered">
              <div class="no-sites">
                <div class="no-site-message-card">
                  <div class="nameline">
                    Create
                    {{ actAsUser && actAsUser.id !== currentUser.id ? actAsUser.getDisplayName() + "'s" : 'Your' }}
                    First Carbon Offset Site!
                  </div>
                  <div class="message">Create a custom map or upload a kml or kmz file.</div>
                  <button (click)="doGoToNewSite()" color="primary" mat-raised-button type="button">Get Started</button>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
        <fc-spinner [zIndex]="999" enhanced="true" name="sites-spinner" text="Loading Your Sites"></fc-spinner>
      </div>
    </div>
  </ng-container>

  <ng-template #notVerified>
    <div class="main-container">
      <div class="main">
        <div *ngIf="availableSites">
          <div class="sites-container centered">
            <div class="no-sites">
              <div class="no-site-message-card">
                <ng-container *ngIf="currentUser.rejectedBy === null; else isManuallyRejected">
                  <div class="nameline">Identity Verification Pending</div>
                  <div class="message">You will receive an email once your identity is verified.</div>
                </ng-container>
                <ng-template #isManuallyRejected>
                  <div class="nameline">Identity Verification Denied</div>
                  <div class="message">
                    Unable to verify, please contact us at {{ helpPhone }} or via email at
                    <a href="mailto:{{ helpEmail }}" rel="noopener noreferrer" target="_blank">
                      {{ helpEmail }}
                    </a>
                    if you have any questions.
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
